export interface PendingOvertime {
    Name?: string;
    RateType?: string;
    Rate?: string;
}

export interface PendingDeleteOvertime {
    awaitingName?: boolean;
}
export const startCreateOvertimeFlow = (
    setPending: (data: PendingOvertime | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPending({ Name: nameFromIntent });
        pushAIChat("What is the overtime rate type? (e.g. Hourly 1.5)");
        speak("What is the overtime rate type?");
        return;
    }

    setPending({});
    pushAIChat("What should the overtime be called?");
    speak("What should the overtime be called?");
};
export const processPendingOvertime = (
    text: string,
    pending: PendingOvertime,
    setPending: (data: PendingOvertime | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — Name
    if (!pending.Name) {
        setPending({ ...pending, Name: text });
        pushAIChat("What is the overtime rate type? (e.g. Hourly 1.5)");
        speak("What is the overtime rate type?");
        return;
    }

    // STEP 2 — Rate Type
    if (!pending.RateType) {
        setPending({ ...pending, RateType: text });
        pushAIChat("What is the overtime rate amount?");
        speak("What is the overtime rate?");
        return;
    }

    // STEP 3 — Rate
    if (!pending.Rate) {
        const finalData = {
            ...pending,
            Rate: text,
        };

        pushAIChat(`Creating overtime "${pending.Name}"...`);
        speak(`Creating overtime ${pending.Name}.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-overtime", {
                detail: finalData,
            })
        );

        setPending(null);
    }
};
export const startDeleteOvertimeFlow = (
    setPendingDelete: (data: PendingDeleteOvertime | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting overtime "${nameFromIntent}"...`);
        speak(`Deleting overtime ${nameFromIntent}.`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-overtime", {
                detail: { name: nameFromIntent },
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which overtime would you like to delete?");
    speak("Which overtime would you like to delete?");
};
export const processPendingDeleteOvertime = (
    text: string,
    pending: PendingDeleteOvertime,
    setPendingDelete: (data: PendingDeleteOvertime | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    pushAIChat(`Deleting overtime "${text}"...`);
    speak(`Deleting overtime ${text}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-overtime", {
            detail: { name: text },
        })
    );

    setPendingDelete(null);
};
